import { useEffect, useState } from 'react';

/**
 * Debounce-Helper für Search-Inputs. Triggert den `value`-Update erst nach `delay`ms
 * Ruhe — vermeidet einen Request pro Tastendruck.
 */
export function useDebounce<T>(value: T, delay = 300): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const handle = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(handle);
  }, [value, delay]);
  return debounced;
}
